import dayjs from 'dayjs'
import { relationship, dateFormat } from 'consts'

export const sortByRelation = (a, b) => {
  const relationshipOrder = {
    [relationship.owner]: 0,
    [relationship.spouse]: 1,
    [relationship.dependent]: 2
  }

  // Get the order of relationship for both a and b
  const orderA = relationshipOrder[a.relation]
  const orderB = relationshipOrder[b.relation]

  // Compare the orders
  if (orderA < orderB) {
    return -1 // a should come before b
  } else if (orderA > orderB) {
    return 1 // b should come before a
  } else {
    return 0 // maintain the original order
  }
}

export const getOwnerMember = members => {
  return members?.find(member => member.relation === relationship.owner)
}

export const getMemberAddress = (member, ownerMember) => {
  const isOwner = member?.id === ownerMember?.id
  const ownerMailingAddress = ownerMember?.isMailingAddressAsHomeAddress
    ? ownerMember?.homeAddress
    : ownerMember?.mailingAddress
  const homeAddress =
    isOwner || member?.isHomeAddressAsOwner
      ? ownerMember?.homeAddress
      : member?.homeAddress
  const mailingAddress =
    isOwner || member?.isMailingAddressAsOwner
      ? ownerMailingAddress
      : member?.mailingAddress

  return { homeAddress, mailingAddress }
}

export const getMemberEmail = member => {
  return member?.email
}

export const getMemberZipCode = member => {
  return member?.homeAddress?.zipCode
}

export const getMemberCounty = member => {
  return member?.homeAddress?.county
}

export const getMember = (state, memberId) => {
  return state?.member?.members?.find(member => member?.id === memberId)
}

export const getMemberEffectiveDate = () => {
  // the effective date is the first day of the next month
  return dayjs()
    .month(dayjs().month() + 1)
    .date(1)
    ?.format(dateFormat)
}

export const getMemberQualificationReasonCode = (
  selectedReason,
  qualificationReasons
) => {
  return qualificationReasons?.find(reason => reason?.code === selectedReason)
    ?.code
}
